export default "__VITE_ASSET__CVDGVDF2__"